import { IInfrastructureData } from 'shared/mf-infrastructure/types/infrastructure';
import { hasFutureObjects } from 'shared/mf-infrastructure/utils/hasFutureObjects';
import { toInfrastructureItems } from 'shared/mf-infrastructure/utils/toInfrastructureItems';

export const hasFutureInfrastructure = (infrastructureMapByYearMap: Map<number, IInfrastructureData>) => {
  const infrastructureItems = toInfrastructureItems(infrastructureMapByYearMap);

  return hasFutureObjects(infrastructureItems);
};
